var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSendMessageIcon = function SvgSendMessageIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7831 3.99712L15.6808 19.6043C15.612 19.7561 15.4911 19.8781 15.3399 19.9483C15.1888 20.0185 15.0176 20.0322 14.8572 19.9869C14.77 19.9613 14.6882 19.9199 14.616 19.8646L10.3281 16.6077L6.91236 19.0575C6.82898 19.1181 6.73297 19.1591 6.63152 19.1772C6.53006 19.1954 6.42581 19.1904 6.32658 19.1626C6.2498 19.142 6.17759 19.1072 6.11373 19.0599C5.99428 18.9779 5.90337 18.8606 5.85368 18.7245C5.80398 18.5884 5.79797 18.4402 5.83647 18.3005L6.83096 14.589L19.0439 5.78819L5.02436 12.5763L1.28324 9.72787C1.17634 9.64908 1.0942 9.54137 1.0465 9.41744C0.99879 9.29351 0.987507 9.15852 1.01398 9.02839C1.04106 8.90125 1.10239 8.78394 1.19134 8.68915C1.28028 8.59436 1.39346 8.5257 1.51862 8.4906L21.971 3.02718C22.0906 2.99276 22.2172 2.991 22.3377 3.02209C22.4702 3.0575 22.5892 3.1312 22.68 3.23397C22.7684 3.33794 22.8252 3.46512 22.8435 3.60041C22.8618 3.7357 22.8408 3.87339 22.7831 3.99712Z",
    fill: "#5656FC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSendMessageIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SendMessageIcon.4018e3f0.svg";
export { ForwardRef as ReactComponent };